$(document).ready(function () {

    var scenario = window.scenarios["3dl_500p_4s"];

    $(".coupon-widget-inner a").on("click", function () {


        $(".login-form-slide-box").removeClass("slide-register");
        $(".popup-action-title").removeClass("active-tab");
        $(".register-title").addClass("active-tab");

        Vivense.loginPopup.open(scenario.widget, scenario.name);

        // Close widget, do not show again
        $('.coupon-widget-inner .close-widget').trigger('click');


    });

    $(".coupon-widget-inner .close-widget").on("click", function () {
        Vivense.cookie.set(scenario.name + '_Closed','1',7 * 24);
        $(".coupon-widget-wrapper").remove();
    });
});